import { getVehicles } from '@/api/vehicles'

const getDefaultState = () => {
  const initialState = {
    list: []
  }

  if (localStorage.getItem('vehicles')) {
    initialState.list = JSON.parse(localStorage.getItem('vehicles'))
  }

  return initialState
}

const state = getDefaultState()

const mutations = {
  SET_VEHICLES: (state, data) => {
    state.list = data
    localStorage.setItem('vehicles', JSON.stringify(data))
  }
}

const actions = {
  getVehiclesList ({ commit }) {
    return new Promise((resolve, reject) => {
      getVehicles().then(response => {
        const data = response.data

        commit('SET_VEHICLES', data)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }
}

const getters = {
  vehicles: state => state.list,
  findVehicle: (state) => id => {
    const vehicleId = parseInt(id)

    if (vehicleId !== 0) {
      return state.list.find(vehicle => vehicle.id === vehicleId)
    }

    return null
  },
  vehicleNewExpirationDate: (state, getters) => id => {
    const vehicle = getters.findVehicle(id)
    let expirationDate = vehicle.expiration_date

    if (vehicle && expirationDate) {
      let newExpirationDate
      const today = new Date()
      expirationDate = new Date(expirationDate)

      if (today > expirationDate) {
        newExpirationDate = new Date(
          today.getFullYear() + 1,
          today.getMonth(),
          today.getDate()
        )
      } else {
        newExpirationDate = new Date(
          expirationDate.getFullYear() + 1,
          expirationDate.getMonth(),
          expirationDate.getDate()
        )
      }

      return newExpirationDate.toLocaleDateString('en-GB')
    }

    return null
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
